﻿<script setup lang="ts">
import { useToast } from '../composables/useToast'
import AppIcon from './AppIcon.vue'

const { messages, remove } = useToast()
</script>

<template>
  <Teleport to="body">
    <div class="toast-stack" aria-live="polite" aria-atomic="true">
      <TransitionGroup name="toast-list">
        <div v-for="message in messages" :key="message.id" class="toast" :class="`toast--${message.tone}`">
          <AppIcon :name="message.tone === 'error' ? 'warning' : message.tone === 'success' ? 'check' : 'info'" :size="19" />
          <span>{{ message.text }}</span>
          <button type="button" class="toast-close" aria-label="Dismiss notification" @click="remove(message.id)">
            <AppIcon name="close" :size="15" />
          </button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>
